import React, { FunctionComponent } from "react";
import ReactDOM from "react-dom";
import {usePortal} from "../../hooks";

export const Modal: FunctionComponent = ({ children }) => {
  const target = usePortal("portals");
  return ReactDOM.createPortal(children, target);
};
